/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Joy.xushaojia
 * @Date: 2023-12-22 13:46:21
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-07-16 11:05:53
 */
import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil'
import { SpinLoading } from 'antd-mobile'

import { getCloudConfig, getTheme } from './utils/public'
const { uiSetting } = getCloudConfig() || {}

// 设置全局变量

// 创建一个 <style> 元素
var styleElement = document.createElement('style');
console.log(uiSetting, getTheme());

// 获取app主题
const theme = getTheme() || 'BLACK'

// 设置样式内容
var css = `:root{
   --brandColor: ${uiSetting?.brandColor.value || '#f7931a'};
   --textH1: ${theme == 'BLACK' ? uiSetting?.textH1.blackValue : uiSetting?.textH1.value};
   --textH2: ${theme == 'BLACK' ? uiSetting?.textH2.blackValue : uiSetting?.textH2.value};
   --textH3: ${theme == 'BLACK' ? 'rgba(255, 255, 255, 0.40)' : 'rgba(255, 255, 255, 0.40)'};
   --cardBackgroud: ${theme == 'BLACK' ? uiSetting?.cardBackgroud.blackValue : uiSetting?.cardBackgroud.value};
   --pageBackgroud: ${theme == 'BLACK' ? uiSetting?.pageBackgroud.blackValue : (uiSetting?.pageBackgroud.value || '#fff')};
   --uploadBackgroud: ${theme == 'BLACK' ? 'rgba(105, 122, 180, 0.06)' : (uiSetting?.pageBackgroud.value || '#fff')};
   --border: ${theme == 'BLACK' ? 'rgba(136, 136, 136, 0.10)' : (uiSetting?.pageBackgroud.value || '#fff')};
  }`;


// 将样式内容添加到 <style> 元素中
styleElement.appendChild(document.createTextNode(css));

// 将 <style> 元素插入到 <head> 元素中
document.head.appendChild(styleElement);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <RecoilRoot>
      <React.Suspense fallback={<SpinLoading color='primary' />}>
        <App />
      </React.Suspense>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
